import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SecurityService } from '../../../services/security/security.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal, { SweetAlertResult } from "sweetalert2";
import { Router } from '@angular/router';

@Component({
  selector: 'app-nuevo-sistema',
  templateUrl: './nuevo-sistema.component.html',
  styleUrls: ['./nuevo-sistema.component.scss'],
  providers: [MessagesTitles, MessagesStatus]
})
export class NuevoSistemaComponent implements OnInit {
  @Output() cerrarPopUpSistema: EventEmitter<boolean>;
  @Output() refresh = new EventEmitter<any>();
  editar: boolean;
  loading: boolean = false;
  isLoading = true;
  save: boolean = false;
  dataSistema: any;
  user: any;
  ipAddress: any;
  formularioSistema: FormGroup;
  idEmpresa: string;
  Titulo: string;

  constructor(private securityService: SecurityService,
    private router: Router,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus) {

    try {
      this.dataSistema = this.securityService.dataSistema;

    } catch (error) {
      this.router.navigate(['/sistema/listado']);
    }

    this.Titulo = "Nuevo Sistema";
    this.cerrarPopUpSistema = new EventEmitter();
    this.editar = false;

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

    this.formularioSistema = new FormGroup({
      id_sistemas: new FormControl(this.dataSistema.id_sistemas),
      Sistema: new FormControl('', [Validators.required]),
      Descripcion: new FormControl('', [Validators.required]),
      Arquitectura: new FormControl('', [Validators.required]),

      NombreProyecto: new FormControl('DigitalFactoring', []),
      Usuario: new FormControl(this.user.Usuario, []),
      Host: new FormControl('INTRANET', []),
      IP: new FormControl(this.ipAddress.ip, []),
      Canal: new FormControl('W', [])
    });
  }

  ngOnInit() {
    if (this.securityService.dataSistema != "") {
      this.loading = true;
      this.Titulo = "Editar Sistema";
      this.editar = true;
      this.formularioSistema.controls['Sistema'].setValue(this.dataSistema.Sistema);
      this.formularioSistema.controls['Descripcion'].setValue(this.dataSistema.Descripcion);
      this.formularioSistema.controls['Arquitectura'].setValue(this.dataSistema.Arquitectura);
    }
    this.loading = false;
  }

  GuardarSistema() {
    if (this.formularioSistema.invalid) {

      Swal.fire({
        title: "CAMPOS VALIDADOS",
        text: "Verficiar los campos resaltados de color rojo",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
    }

    if (this.editar) {

      Swal.fire({
        title: 'Espere',
        text: 'Actualizando Información',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      Swal.showLoading();


      this.securityService.ActualizarSistema(this.formularioSistema.getRawValue())
        .subscribe(resp => {

          Swal.fire({
            title: "Éxito",
            text: "Sistema actualizado correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(res => {
            this.redirect(res);
          });
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          if (err.error instanceof ErrorEvent) {
            console.error(err);
          } else {
            this.msgStatus.getMessage(err.status);
          }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "SISTEMA NO ACTUALIZADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });
    } else {
      Swal.fire({
        title: 'Espere',
        text: 'Guardando información',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      Swal.showLoading();

      this.securityService.RegistrarSistema(this.formularioSistema.getRawValue())
        .subscribe(resp => {

          Swal.fire({
            title: "Éxito",
            text: "Sistema guardado correctamente.",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(res => {
            this.redirect(res);
          });
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          if (err.error instanceof ErrorEvent) {
            console.error(err);
          } else {
            this.msgStatus.getMessage(err.status);
          }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "SISTEMA NO GUARDADO. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });
    }
  }
  redirect(res: SweetAlertResult) {
    if (res.value) {
      this.cerrarPopUpSistema.emit();
      this.refresh.emit();
      this.router.navigate(['/sistema/listado']);
    }
  }

  CerrarPopUp() {
    this.cerrarPopUpSistema.emit();
  }
}
